export default __webpack_public_path__ + "static/media/1439.8d80041e.jpg";